{
	"title": "Zapewnianie rozliczalności poprzez wdrożenie banku węglowego",
	"description": "Heidelberg Materials podjęła kompleksowe działania, aby zagwarantować wiarygodność redukcji emisji dwutlenku węgla generowanych przez naszą cementownię z CCS. Aby zapobiec jakiejkolwiek możliwości podwójnego rozliczania, wdrożyliśmy bezpieczny wirtualny bank węglowy w publicznym rejestrze rozproszonym.",
	"traceabilityTitle": "Możliwość śledzenia redukcji emisji dwutlenku węgla"
}
